/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.refund.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.order',
  'acme.common.service.calendar',
  'acme.common.service.helpers',
  'acme.common.factory.notice',
  'acme.common.service.userPreferences',
  'acme.view.application.orders.refund.confirmModal.controllers'
])

.controller('OrdersRefundController', ['$scope', '$state', '$filter', '$uibModal', '$timeout', 'ApiService', 'CalendarService', 'OrderService', 'HelpersService', 'NoticeFactory', 'OrderData', 'UserPreferencesService', function($scope, $state, $filter, $uibModal, $timeout, ApiService, CalendarService, OrderService, HelpersService, NoticeFactory, OrderData, UserPreferencesService) {

    $scope.ordersRefund = {

      model: {},
      refundModal: {},
      notes: '',
      isProcessing: false,
      sendEmail: true,
      totalQuantity: 0,
      totalAmount: 0,
      incidentReasonCodes: [],
      selectedIncidentReasonCode: null,
      getItemType: OrderService.getItemType,
      dateFormat: UserPreferencesService.getDateFormat('tinyDate', 'dateFormat'),
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
      notice: new NoticeFactory(),
      details: {
        columns: 3,
        data: 'ordersRefund.model',
        sorting: true,
        include: [
          'orderNumber',
          'phoneNumber',
          'email',
          'contactFirstName',
          'contactLastName'
        ]
      },
      orderNotes: {
        columns: 1,
        data: 'ordersRefund.model',
        include: [
          'notes'
        ],
        mappings: {
          'notes': 'Order Notes'
        }
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Cancel Order and Refund',
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $scope.ordersRefund.cancel();
            }
          },
          buttonRight: {
            label: 'Confirm Cancellation and Refund',
            action: function() {
              $scope.ordersRefund.complete();
            }
          }
        });
        
        if (OrderData && OrderData.data.success) {
          this.success.init(OrderData);
        }else{
          this.error.init(OrderData);
        }

        this.getIncidentReasonCodes();        

      },

      getIncidentReasonCodes: function() {
        ApiService.tenant.reasons.list().then(this.success.getIncidentReasonCodes, this.error.getIncidentReasonCodes);
      },

      hasIncidentReasonCodes: function() {
        return (this.incidentReasonCodes instanceof Array && this.incidentReasonCodes.length);
      },

      resetModel: function() {
        var i, ii,
            j, jj;

        this.totalQuantity = 0;
        this.totalAmount = 0;

        for (i=0,ii=this.model.eventItems.length;i<ii;i++) {
          for (j = 0, jj = this.model.eventItems[i].items.length; j < jj; j++) {
            this.model.eventItems[i].items[j].refundQuantity = 0;
            this.model.eventItems[i].items[j].refundAmount = 0;
          }

          this.model.eventItems[i].refundQuantity = 0;
          this.model.eventItems[i].refundAmount = 0;

        }
      },

      process: function(order) {

        var i, ii,
            j, jj;

        for (i=0,ii=order.eventItems.length;i<ii;i++) {
          for (j=0,jj=order.eventItems[i].items.length;j<jj;j++) {
            order.eventItems[i].items[j].refundQuantity = 0;
            order.eventItems[i].items[j].refundAmount = 0;
          }

          order.eventItems[i].refundQuantity = 0;
          order.eventItems[i].refundAmount = 0;

          if (order.eventItems[i].eventDate) {
            order.eventItems[i].startDate = $filter('date')(CalendarService.parseDate(order.eventItems[i].eventDate), $scope.ordersRefund.dateFormat);
            order.eventItems[i].startHour = $filter('date')(CalendarService.parseDate(order.eventItems[i].eventDate), $scope.ordersRefund.hourFormat);
          }else{
            order.eventItems[i].startDate = 'Date N/A';
            order.eventItems[i].startHour = 'Time N/A';
          }

        }

        return order;

      },

      calculateRefunds: function() {
        var self = $scope.ordersRefund,
          i, ii,
          j, jj;

        for (i=0,ii=self.model.eventItems.length;i<ii;i++) {
          for (j = 0, jj = self.model.eventItems[i].items.length; j < jj; j++) {
            self.model.eventItems[i].items[j].refundQuantity = self.model.eventItems[i].items[j].quantity;
            self.calculateTotal(self.model.eventItems[i].items[j]);
          }
        }
      },

      cancel: function() {
        this.resetModel();
        window.history.go(-1);
      },

      calculateTotal: function(item) {
        var total;

        if (item.refundQuantity > item.quantity) {
          item.refundQuantity = item.quantity;
        }

        if (item.discountedUnitPrice) {
          total = item.refundQuantity * HelpersService.currencyFloatToInteger(item.discountedUnitPrice);
        }else {
          total = item.refundQuantity * HelpersService.currencyFloatToInteger(item.unitPrice);
        }
        item.refundAmount = HelpersService.integerToCurrencyFloat(total);

        this.calculateSubTotals();
      },

      calculateSubTotals: function() {
        var i, ii,
            j, jj,
            amount = 0,
            quantity = 0,
            totalAmount = 0,
            totalQuantity = 0;

        for (i=0,ii=this.model.eventItems.length;i<ii;i++) {
          amount = 0;
          quantity = 0;

          for (j=0,jj=this.model.eventItems[i].items.length;j<jj;j++) {
            quantity += this.model.eventItems[i].items[j].refundQuantity;
            amount += HelpersService.currencyFloatToInteger(this.model.eventItems[i].items[j].refundAmount);
          }
          totalAmount += amount;
          totalQuantity += quantity;
          this.model.eventItems[i].refundQuantity = quantity;
          this.model.eventItems[i].refundAmount = HelpersService.integerToCurrencyFloat(amount);
        }
        this.totalQuantity = totalQuantity;
        this.totalAmount = HelpersService.integerToCurrencyFloat(totalAmount);
      },

      getRefundQuantity: function(ticket) {
        return ticket.quantity;
      },

      getRefundAmount: function() {
        return (this.totalAmount - this.model.orderBalance);
      },

      getRefundItems: function() {
        var i, ii,
            j, jj,
            items = [],
            code;

        for (i=0,ii=this.model.eventItems.length;i<ii;i++) {
          for (j=0,jj=this.model.eventItems[i].items.length;j<jj;j++) {

            code = {
              orderItemId: this.model.eventItems[i].items[j].orderItemId,
              quantity:  this.model.eventItems[i].items[j].refundQuantity
            };

            if (this.selectedIncidentReasonCode) {
              code.incidentReasonCode = this.selectedIncidentReasonCode;
            }

            items.push(code);
          }
        }

        return items;
      },

      complete: function() {
        var self = $scope.ordersRefund;

        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();

        if (this.totalQuantity > 0) {
          if (this.getRefundAmount() > 0) {
            self.refundModal = $uibModal.open({
              templateUrl: 'views/application/views/orders/refund/modals/confirm.tpl.html',
              controller: 'OrdersRefundConfirmModalController',
              resolve: {
                currentRefund: function () {
                  return {
                    total: self.totalAmount,
                    quantity: self.totalQuantity
                  };
                }
              }
            });

            // Invoked when modal completes with close(params)
            self.refundModal.result.then(function () {
              self.refund();
            }, function () {
              // Do nothing
            });
          } else {
            self.refund();
          }
        }else{
          this.notice.showErrorMessages([{ message: 'You must add tickets to your refund.'}]);
        }
      },

      refund: function() {
        var refund = {
              orderId: this.model.orderId,
              noEmail: !this.sendEmail,
              notes: (this.model.notes ? '\n' : '') + (this.notes || ''),
              refundItems: []
            };

        this.isProcessing = true;

        if (this.selectedIncidentReasonCode) {
          refund.incidentReasonCode = this.selectedIncidentReasonCode;
        }

        ApiService.refunds.refund(refund).then(this.success.refund, this.error.refund);
      },

      success: {
        init: function(response) {
          var self = $scope.ordersRefund;

          self.model = self.process(response.data.payload);
          self.voucherNumber = self.model.paymentId;
          //calculate totals and refunds for the cancellation
          self.calculateRefunds();
        },
        refund: function(response) {
          var self = $scope.ordersRefund;

          self.isProcessing = false;
          self.resetModel();
          $state.go('application.orders.detail.summary', { orderId: response.data.payload.order.id });
        },
        getIncidentReasonCodes: function(response) {
          var self = $scope.ordersRefund;

          $timeout(function() {
            self.incidentReasonCodes = response.data.payload;
          }, 0);
        }
      },

      error: {
        init: function(response) {
          var self = $scope.ordersRefund;
        },
        refund: function(response) {
          var self = $scope.ordersRefund;

          self.isProcessing = false;
          self.notice.showErrorMessages([{ message: 'An error has occurred: ' + response.data.error }]);
        },
        getIncidentReasonCodes: function(response) {
          // Ignore this error

        }
      }

    };
    
    $scope.ordersRefund.init();

}]);